module.exports = __webpack_public_path__ + "static/media/work_accident_white.b3a5d338.svg";